import { z } from "zod/v4";
import {
  createOverviewSearchSchema,
  overviewFilterValues,
} from "#/modules/util.overview/schema.search";

/**
 * Search params schema for the tickets admin overview: searchTerm, sort, status filter
 * (Open/Closed), pagination.
 */
const { schema, defaults } = createOverviewSearchSchema({
  orderBy: "lastActivityAt",
  orderDirection: "descending",
  extra: {
    status: overviewFilterValues(),
  },
});

export const ticketsAdminSearchSchema = schema;

/** Default values for tickets admin search params; values not explicitly set will be omitted from URL. */
export const TICKETS_ADMIN_SEARCH_DEFAULTS = defaults;

export type TicketsAdminSearch = z.infer<typeof ticketsAdminSearchSchema>;
